import React, { useEffect, useState } from "react";
import { richTextFromMarkdown } from "@contentful/rich-text-from-markdown";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { CTATrackingTarget } from "../../components/analytics/track";
import trackComponentAction from "../../components/analytics/trackComponentAction";

interface IMessageTextProps {
  text: string;
}

export const MessageText: React.FC<IMessageTextProps> = ({ text }) => {
  const [parsedContent, setParsedContent] = useState<React.ReactNode>(text);

  useEffect(() => {
    richTextFromMarkdown(text)
      .then((document) => {
        setParsedContent(
          documentToReactComponents(document, {
            renderNode: {
              hyperlink: (node, children) => {
                const url = node.data.uri;
                return (
                  <a
                    href={url}
                    onClick={(e) => {
                      e.preventDefault();
                      if (url.includes("my.upsolve.org")) {
                        trackComponentAction({
                          componentName: "topOfFunnelAi_message",
                          componentVersion: "1",
                          actionId: CTATrackingTarget.SCREENER,
                          actionMethod: "click",
                          extras: {
                            url,
                          },
                        });
                      } else {
                        trackComponentAction({
                          componentName: "topOfFunnelAi_message",
                          componentVersion: "1",
                          actionId: "link_click",
                          actionMethod: "click",
                          extras: {
                            url,
                          },
                        });
                      }
                      window.open(url, "_blank");
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {children}
                  </a>
                );
              },
            },
          })
        );
      })
      .catch(() => {
        setParsedContent(text);
      });
  }, [text]);

  return <>{parsedContent}</>;
};
